// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var CustomerInfo$ReactHooksTemplate = require("./CustomerInfo.res.js");
var OpinionScale$ReactHooksTemplate = require("./OpinionScale.res.js");
var QuestionText$ReactHooksTemplate = require("./QuestionText.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");
var MandatoryMessage$ReactHooksTemplate = require("./MandatoryMessage.res.js");
var OpinionScaleLabel$ReactHooksTemplate = require("./OpinionScaleLabel.res.js");
var OrganizationProfile$ReactHooksTemplate = require("../settings/organizationProfile.res.js");
var OpinionScaleDefaultForm$ReactHooksTemplate = require("./OpinionScaleDefaultForm.res.js");

function OpinionScaleForm$OpinionScaleItem(props) {
  var onSelection = props.onSelection;
  var step = props.step;
  var tmp;
  tmp = props.representation === "Plain" ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("span", {
                children: String(step)
              }),
          className: "py-5 small:py-2"
        });
  return JsxRuntime.jsx("button", {
              children: tmp,
              className: props.className,
              style: props.style,
              onClick: (function ($$event) {
                  $$event.preventDefault();
                  Curry._1(onSelection, step);
                })
            });
}

var OpinionScaleItem = {
  make: OpinionScaleForm$OpinionScaleItem
};

function colorBasedOnLikelyness(index) {
  switch (index) {
    case 0 :
        return "#cf0000";
    case 1 :
        return "#da0000";
    case 2 :
        return "#f12500";
    case 3 :
        return "#ff331a";
    case 4 :
        return "#ff4118";
    case 5 :
        return "#ff541a";
    case 6 :
        return "#ff8000";
    case 7 :
        return "#ffc400";
    case 8 :
        return "#ffd50c";
    case 9 :
        return "#1abf00";
    case 10 :
        return "#169f00";
    default:
      return "#ffffff";
  }
}

function OpinionScaleForm(props) {
  var substitutionVariables = props.substitutionVariables;
  var onChange = props.onChange;
  var mandatory = props.mandatory;
  var language = props.language;
  var opinionScale = props.opinionScale;
  var selectedRating = OpinionScale$ReactHooksTemplate.rating(opinionScale);
  var selectedCss = function (x) {
    if (OpinionScale$ReactHooksTemplate.isAnswer(opinionScale, x)) {
      return "text-blue-800";
    } else {
      return "";
    }
  };
  var likelyness;
  if (selectedRating !== undefined) {
    switch (selectedRating) {
      case 0 :
      case 1 :
          likelyness = {
            TAG: "VeryUnlikely",
            _0: selectedRating
          };
          break;
      case 2 :
      case 3 :
      case 4 :
      case 5 :
      case 6 :
          likelyness = {
            TAG: "Unlikely",
            _0: selectedRating
          };
          break;
      case 7 :
      case 8 :
          likelyness = {
            TAG: "Maybe",
            _0: selectedRating
          };
          break;
      case 9 :
          likelyness = {
            TAG: "Likely",
            _0: selectedRating
          };
          break;
      case 10 :
          likelyness = {
            TAG: "ExtremelyLikely",
            _0: selectedRating
          };
          break;
      default:
        likelyness = undefined;
    }
  } else {
    likelyness = undefined;
  }
  var filledBackgroundCSS;
  if (likelyness !== undefined) {
    switch (likelyness.TAG) {
      case "VeryUnlikely" :
          filledBackgroundCSS = "very-unlikely";
          break;
      case "Unlikely" :
          filledBackgroundCSS = "unlikely";
          break;
      case "Maybe" :
          filledBackgroundCSS = "maybe";
          break;
      case "Likely" :
          filledBackgroundCSS = "likely";
          break;
      case "ExtremelyLikely" :
          filledBackgroundCSS = "extremely-likely";
          break;
      
    }
  } else {
    filledBackgroundCSS = "";
  }
  var ratingEmoji;
  if (likelyness !== undefined) {
    switch (likelyness.TAG) {
      case "VeryUnlikely" :
          ratingEmoji = Image$ReactHooksTemplate.veryUnlikelySmiley;
          break;
      case "Unlikely" :
          ratingEmoji = Image$ReactHooksTemplate.unlikelySmiley;
          break;
      case "Maybe" :
          ratingEmoji = Image$ReactHooksTemplate.maybeSmiley;
          break;
      case "Likely" :
          ratingEmoji = Image$ReactHooksTemplate.likelySmiley;
          break;
      case "ExtremelyLikely" :
          ratingEmoji = Image$ReactHooksTemplate.extremelyLikelySmiley;
          break;
      
    }
  } else {
    ratingEmoji = "";
  }
  var ratingMessage;
  if (likelyness !== undefined) {
    switch (likelyness.TAG) {
      case "VeryUnlikely" :
          ratingMessage = "Very Unhappy!";
          break;
      case "Unlikely" :
          ratingMessage = "Unhappy!";
          break;
      case "Maybe" :
          ratingMessage = "It was ok!";
          break;
      case "Likely" :
          ratingMessage = "Happy!";
          break;
      case "ExtremelyLikely" :
          ratingMessage = "Super Happy!";
          break;
      
    }
  } else {
    ratingMessage = "";
  }
  var rmName = CustomerInfo$ReactHooksTemplate.rmName(props.customerInfo);
  var questionText = OpinionScale$ReactHooksTemplate.getTextTranslation(opinionScale, SurveyLanguage$ReactHooksTemplate.name(language)).replace("${RM_NAME}", rmName);
  var ratings = $$Array.of_list(Belt_List.mapWithIndex(Belt_List.makeBy(11, (function (x) {
                  return x;
                })), (function (i, param) {
              return JsxRuntime.jsx("p", {
                          children: String(i)
                        });
            })));
  var items = function (a, b) {
    return $$Array.of_list(Belt_List.mapWithIndex(Belt_List.makeBy((b - a | 0) + 1 | 0, (function (x) {
                          return x;
                        })), (function (i, x) {
                      var match = OpinionScale$ReactHooksTemplate.representation(opinionScale);
                      var tmp;
                      tmp = match === "Plain" ? "w-full" : "w-1/11 focus:outline-none text-white text-xl font-medium " + selectedCss(x);
                      var match$1 = OpinionScale$ReactHooksTemplate.representation(opinionScale);
                      var tmp$1;
                      tmp$1 = match$1 === "Plain" ? ({}) : ({
                            backgroundColor: colorBasedOnLikelyness(i)
                          });
                      return JsxRuntime.jsx(OpinionScaleForm$OpinionScaleItem, {
                                  step: x + a | 0,
                                  className: tmp,
                                  onSelection: (function (scale) {
                                      Curry._1(onChange, OpinionScale$ReactHooksTemplate.setAnswer(opinionScale, scale));
                                    }),
                                  style: tmp$1,
                                  representation: OpinionScale$ReactHooksTemplate.representation(opinionScale)
                                }, String(i + a | 0));
                    })));
  };
  var match = OrganizationProfile$ReactHooksTemplate.name(props.client);
  switch (match) {
    case "bhima" :
    case "ncell" :
    case "nykaa" :
        break;
    default:
      return JsxRuntime.jsx(OpinionScaleDefaultForm$ReactHooksTemplate.make, {
                  opinionScale: opinionScale,
                  language: language,
                  mandatory: mandatory,
                  onChange: onChange,
                  borderCss: props.borderCss,
                  substitutionVariables: substitutionVariables
                });
  }
  var match$1 = OpinionScale$ReactHooksTemplate.representation(opinionScale);
  var tmp;
  if (match$1 === "Plain") {
    var tmp$1;
    if (likelyness !== undefined) {
      var tmp$2;
      if (likelyness.TAG === "ExtremelyLikely") {
        tmp$2 = JsxRuntime.jsx("div", {
              children: items(0, 10),
              className: " flex justify-between divide-x w-full\n          " + filledBackgroundCSS + " h-78-px small:h-48-px rounded-lg\n            divide-tropicalbreeze mb-16-px small:mb-8-px"
            });
      } else {
        var rating = likelyness._0;
        var filledCount = String(rating + 1 | 0);
        var unFilledCount = String(11 - (rating + 1 | 0) | 0);
        tmp$2 = JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: items(0, rating),
                      className: "flex justify-between divide-x w-" + filledCount + "/11\n          h-78-px small:h-48-px rounded-lg rounded-r-none divide-tropicalbreeze\n            " + filledBackgroundCSS
                    }),
                JsxRuntime.jsx("div", {
                      children: items(rating + 1 | 0, 10),
                      className: " flex justify-between divide-x w-" + unFilledCount + "/11\n          bg-tropicalbreeze h-78-px small:h-48-px rounded-lg rounded-l-none divide-herringsilver"
                    })
              ],
              className: "flex w-full mb-17-px small:mb-4-px bg-tropicalbreeze rounded-lg"
            });
      }
      tmp$1 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [
              tmp$2,
              JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("img", {
                            className: "mx-auto w-200-px small:w-160-px h-200-px\n                  small:h-160-px mb-8-px",
                            src: ratingEmoji
                          }),
                      JsxRuntime.jsx("p", {
                            children: ratingMessage,
                            className: "font-normal font-semibold text-2xl small:text-xl leading-8\n                  small:leading-4 text-center tracking-wide"
                          })
                    ],
                    className: "w-full flex flex-col items-center"
                  })
            ]
          });
    } else {
      tmp$1 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [
              JsxRuntime.jsx("div", {
                    children: items(0, 10),
                    className: "flex justify-between divide-x w-full\n          bg-tropicalbreeze h-78-px small:h-48-px rounded-lg divide-herringsilver\n          mb-17-px small:mb-4-px"
                  }),
              JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("span", {
                                    children: JsxRuntime.jsx("img", {
                                          className: "w-60-px h-60-px",
                                          src: Image$ReactHooksTemplate.sadRedSmiley
                                        })
                                  }),
                              JsxRuntime.jsx("p", {
                                    children: OpinionScaleLabel$ReactHooksTemplate.left(OpinionScale$ReactHooksTemplate.getLabelTranslation(opinionScale, SurveyLanguage$ReactHooksTemplate.name(language)))
                                  })
                            ],
                            className: "flex flex-col text-center items-start"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("span", {
                                    children: JsxRuntime.jsx("img", {
                                          className: "w-60-px h-60-px",
                                          src: Image$ReactHooksTemplate.happyGreenSmiley
                                        })
                                  }),
                              JsxRuntime.jsx("p", {
                                    children: OpinionScaleLabel$ReactHooksTemplate.right(OpinionScale$ReactHooksTemplate.getLabelTranslation(opinionScale, SurveyLanguage$ReactHooksTemplate.name(language)))
                                  })
                            ],
                            className: "flex flex-col text-center items-end"
                          })
                    ],
                    className: "flex justify-between w-full text-base small:text-sm font-semibold\n          leading-4 tracking-wide"
                  }),
              mandatory ? JsxRuntime.jsxs("p", {
                      children: [
                        "* ",
                        JsxRuntime.jsx("span", {
                              children: "Request your response. This is a mandatory question",
                              className: "text-xs"
                            })
                      ],
                      className: " w-full pt-6 small:pt-3\n            text-lg opacity-50"
                    }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
            ]
          });
    }
    tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
                  children: ratings,
                  className: "flex justify-between w-full font-semibold text-base\n          text-center tracking-wide font-normal mb-8-px small:mb-4-px"
                }),
            tmp$1
          ],
          className: "flex flex-col justify-between items-start"
        });
  } else {
    tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
                  children: items(0, 10),
                  className: "flex border rounded-sm justify-between divide-x w-full\n            border-white bg-white"
                }),
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("p", {
                                  children: OpinionScaleLabel$ReactHooksTemplate.left(OpinionScale$ReactHooksTemplate.getLabelTranslation(opinionScale, SurveyLanguage$ReactHooksTemplate.name(language)))
                                }),
                            JsxRuntime.jsx("span", {
                                  children: JsxRuntime.jsx("img", {
                                        className: "h-5",
                                        src: Image$ReactHooksTemplate.sadRedSmileyYesbank
                                      }),
                                  className: "flex justify-center"
                                })
                          ],
                          className: "flex flex-col text-center"
                        }),
                    JsxRuntime.jsx("p", {
                          children: OpinionScaleLabel$ReactHooksTemplate.center(OpinionScale$ReactHooksTemplate.getLabelTranslation(opinionScale, SurveyLanguage$ReactHooksTemplate.name(language)))
                        }),
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("p", {
                                  children: OpinionScaleLabel$ReactHooksTemplate.right(OpinionScale$ReactHooksTemplate.getLabelTranslation(opinionScale, SurveyLanguage$ReactHooksTemplate.name(language)))
                                }),
                            JsxRuntime.jsx("span", {
                                  children: JsxRuntime.jsx("img", {
                                        className: "h-5",
                                        src: Image$ReactHooksTemplate.happyGreenSmileyYesbank
                                      }),
                                  className: "flex justify-center"
                                })
                          ],
                          className: "flex flex-col justify-center"
                        })
                  ],
                  className: " flex justify-between w-full pt-6 small:pt-3\n            text-lg small:text-xs pb-10 "
                }),
            mandatory ? JsxRuntime.jsx(MandatoryMessage$ReactHooksTemplate.make, {
                    language: language
                  }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
          ],
          className: "flex flex-col justify-between items-start"
        });
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(QuestionText$ReactHooksTemplate.make, {
                      text: questionText,
                      description: OpinionScale$ReactHooksTemplate.getDescriptionTranslation(opinionScale, SurveyLanguage$ReactHooksTemplate.name(language)),
                      mandatory: mandatory,
                      surveyTheme: props.surveyTheme,
                      substitutionVariables: substitutionVariables
                    }),
                tmp
              ],
              className: "w-full py-8 px-16 small:px-6"
            });
}

var make = OpinionScaleForm;

exports.OpinionScaleItem = OpinionScaleItem;
exports.colorBasedOnLikelyness = colorBasedOnLikelyness;
exports.make = make;
/* react/jsx-runtime Not a pure module */
